export default __webpack_public_path__ + "static/media/Family.e9b12159.webp";